import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { getAllManufacturers as onGetAllManufacturers } from "store/products/actions"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"

const AddNewManufacturer = props => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    manufacturerName: null,
  })

  const [manufacturerName, setManufacturerName] = useState('')
  const [manufacturerDescription, setManufacturerDescription] = useState('')
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('inp-manu-name').focus();
      document.getElementById('inp-manu-name').select();
    }, 250);
    
    if(props.enteredText != ''){
      setManufacturerName(props.enteredText)
    }
  }, [props.enteredText])

  useEffect(() => {
    if(props.isEdit){
      setManufacturerName(props.detailsForEdit.name)
      setManufacturerDescription(props.detailsForEdit.details)
    }
  }, [props.detailsForEdit])

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    if(manufacturerName && manufacturerName != ""){
      modifiedV["manufacturerName"] = true
    }
    else{
      modifiedV["manufacturerName"] = false
      formValid = false
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()

    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputKey': manufacturerName,
        'inputValue' : manufacturerDescription
      }, 'Manufacturer')
      setShowLoading(false)
      if(response.status == 'success'){
        dispatch(onGetAllManufacturers(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'value': props.detailsForEdit.value,
          'name': manufacturerName,
          'details' : manufacturerDescription
        }, 'Manufacturer')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllManufacturers(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inp-manu-name">
                              Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inp-manu-name"
                              maxLength="150"
                              value={manufacturerName}
                              onChange={event => {
                                onChangeValidation("manufacturerName", event.target.value.trim())
                                setManufacturerName(event.target.value)
                              }}
                              invalid={
                                validation["manufacturerName"] !== true &&
                                validation["manufacturerName"] !== null
                              }
                            />
                            {(validation["manufacturerName"] === false) &&
                              <div className="custom-error">
                                Please enter the Manufacturer Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpname">
                              Details
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpname"
                              maxLength="200"
                              value={manufacturerDescription}
                              onChange={event => {
                                onChangeValidation("manufacturerDescription", event.target.value.trim())
                                setManufacturerDescription(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                SAVE
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewManufacturer.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewManufacturer
